let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("4Vk0I")]).then(() => parcelRequire('8xd8j'));